import { render, staticRenderFns } from "./RemoveRule.vue?vue&type=template&id=0ad4ea1e&scoped=true&"
import script from "./RemoveRule.vue?vue&type=script&lang=js&"
export * from "./RemoveRule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ad4ea1e",
  null
  
)

export default component.exports